import { ChevronDown } from 'baseui/icon';
import { string2money } from 'common/utils/string';
import HOCWatchValue from 'components/common/hoc-watch-value';
import Separator from 'components/common/separator';
import { IconButton } from 'components/elements/buttons';
import Text from 'components/elements/text';
import useDrawer from 'hooks/use-drawer';
import { SummaryContent, SummaryLeftContainer } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import SummaryDrawer from './drawer';
import { totalFlightRescheduleCalculation } from '../total-calculation';

export default function SummaryFlightReschedule() {
  const { t } = useTranslation();
  const drawer = useDrawer();
  const values = HOCWatchValue({ keys: ['flightSales'] });

  const total = totalFlightRescheduleCalculation(values.flightSales);

  const onOpenSummary = () => {
    drawer.showCustom({
      backdropClose: true,
      render: (onClose) => (
        <SummaryDrawer
          onClose={onClose}
          total={total}
          flightSales={values.flightSales}
        />
      ),
    });
  };

  return (
    <SummaryContent>
      <SummaryLeftContainer>
        <Text variant={{ initial: 'LabelSmall', md: 'LabelLarge' }}>
          {t('common:total_sales')}:
        </Text>
        <Separator gap={16} direction="horizontal">
          <Text
            variant={{ initial: 'HeadingXSmall', md: 'HeadingSmall' }}
          >{`Rp. ${string2money(total)}`}</Text>
        </Separator>
        <IconButton buttonType="tertiary" onClick={onOpenSummary}>
          <ChevronDown size={24} />
        </IconButton>
      </SummaryLeftContainer>
    </SummaryContent>
  );
}
